import { render, staticRenderFns } from "./ProjectIntroduce.vue?vue&type=template&id=60be3d87&scoped=true&"
import script from "./ProjectIntroduce.vue?vue&type=script&lang=ts&"
export * from "./ProjectIntroduce.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectIntroduce.vue?vue&type=style&index=0&id=60be3d87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be3d87",
  null
  
)

export default component.exports